export default "__VITE_ASSET__CfaYMhCM__"